import { createSimpleNamedExpressionResolver } from '../types';
import { flatten } from 'lodash-es';
import { FlattenExpression } from '@trackback/widgets';

export const flattenResolver = createSimpleNamedExpressionResolver<
  FlattenExpression<any[]>
>('flatten', flatten);
